import { ANALYTIC_COMPARISON_CONSTS as ACC } from '../consts'
import services from '@/services/ascentiaServiceIndex'

const state = {
  analyticComponents: [],
  analytics: [],
  features: [],
  riskScores: [],
}

const getters = {
  mappedAccAnalytics: (state, getters, rootState, rootGetters) => {
    if (state.analytics) {
      const selections = rootGetters['globalFilter/selections']

      return state.analytics
        .filter(
          item =>
            selections.length === 0 ||
            selections.filter(
              selection =>
                item.airlineIds.includes(selection.airlineId) &&
                selection.masterModelId === item.masterModelId,
            ).length > 0,
        )
        .map(item => {
          return {
            ...item,
            analyticId: item.analyticId,
            text: item.name,
            value: item.analyticId,
          }
        })
    }
    return []
  },
  mappedAccAnalyticsAll: state => {
    if (state.analytics) {
      return state.analytics.map(item => {
        return {
          ...item,
          analyticId: item.analyticId,
          text: item.name,
          value: item.analyticId,
        }
      })
    }
    return []
  },
  mappedAccRiskScores: state => {
    if (state.riskScores) {
      return state.riskScores.map(item => {
        const name = item.name || ''
        const riskScore = name.toLowerCase().includes('score')
        const feature = name.toLowerCase().includes('feature')
        return {
          ...item,
          riskScoreId: item.subResultId,
          text: item.name,
          value: item.subResultId,
          isRiskScore: riskScore,
          isFeature: feature,
        }
      })
    }
    return []
  },
}

const mutations = {
  [ACC.UPDATE_ACC_ANALYTIC_COMPONENTS]: (state, data) =>
    (state.analyticComponents = data),
  [ACC.UPDATE_ACC_ANALYTICS]: (state, data) => (state.analytics = data),
  [ACC.UPDATE_ACC_FEATURES]: (state, data) => (state.features = data),
  [ACC.UPDATE_ACC_RISK_SCORES]: (state, data) => (state.riskScores = data),
}

const actions = {
  async [ACC.GET_ACC_ANALYTIC_COMPONENTS]({ commit }) {
    try {
      const response = await services.analyticComparison.getData(
        'analyticComponents',
      )
      const data = response.data
      commit(ACC.UPDATE_ACC_ANALYTIC_COMPONENTS, data)
    } catch (error) {
      console.log(ACC.GET_ACC_ANALYTIC_COMPONENTS + ': error ' + error)
    }
  },
  async [ACC.GET_ACC_ANALYTICS]({ commit }) {
    try {
      const response = await services.analyticComparison.getData('analytics')
      const data = response.data
      commit(ACC.UPDATE_ACC_ANALYTICS, data)
    } catch (error) {
      console.log(ACC.GET_ACC_ANALYTICS + ': error ' + error)
    }
  },
  async [ACC.GET_ACC_FEATURES]({ commit }) {
    try {
      const response = await services.analyticComparison.getData(
        'analyticFeatures',
      )
      const data = response.data
      commit(ACC.UPDATE_ACC_FEATURES, data)
    } catch (error) {
      console.log(ACC.GET_ACC_FEATURES + ': error ' + error)
    }
  },
  async [ACC.GET_ACC_RISK_SCORES]({ commit }) {
    try {
      const response = await services.analyticComparison.getData(
        'analyticRiskScores',
      )
      const data = response.data
      commit(ACC.UPDATE_ACC_RISK_SCORES, data)
    } catch (error) {
      console.log(ACC.GET_ACC_RISK_SCORES + ': error ' + error)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
